<ng-template #index>
  <mat-nav-list class="index">
    @for (s of sections(); track s.sectionId) {
      <button
        mat-list-item
        type="button"
        [disabled]="s.locked"
        [class.locked]="s.locked"
        [activated]="s.sectionId === activeId()"
        [attr.aria-current]="s.sectionId === activeId() ? 'true' : null"
        (click)="scrollTo(s.sectionId)"
      >
        @if (s.icon) {
          <mat-icon matListItemIcon>{{ s.icon }}</mat-icon>
        }
        <span matListItemTitle>{{ s.title }}</span>
        <!-- The list's trailing slot sets its own font, which would turn an icon placed in it into its ligature text. -->
        @if (s.status === 'error') {
          <span matListItemMeta class="status error">
            <mat-icon
              [matBadge]="s.errorCount"
              [matBadgeHidden]="s.errorCount === 0"
              matBadgeSize="small"
              matBadgeColor="warn"
              >error_outline</mat-icon
            >
          </span>
        } @else if (s.status === 'done') {
          <span matListItemMeta class="status done">
            <mat-icon>check_circle</mat-icon>
          </span>
        }
      </button>
    }
  </mat-nav-list>
</ng-template>

<mat-sidenav-container
  [class.compact]="showIndex && compact()"
  [class.single]="!showIndex || compact()"
>
  @if (showIndex) {
    <mat-sidenav
      class="index-drawer"
      mode="over"
      position="end"
      fixedInViewport
    >
      <ng-container *ngTemplateOutlet="index" />
    </mat-sidenav>
  }
  <mat-sidenav-content>
    @if (showIndex && compact()) {
      <div class="index-bar">
        <span class="current">{{ activeTitle() }}</span>
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="'sections' | i18nextCap"
          (click)="openIndex()"
        >
          <mat-icon>toc</mat-icon>
        </button>
      </div>
    }
    <div class="layout">
      @if (showIndex && !compact()) {
        <nav class="rail">
          <ng-container *ngTemplateOutlet="index" />
        </nav>
      }
      <div class="sections">
        <ng-content></ng-content>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
